import { render, staticRenderFns } from "./CheckUserAndReload.vue?vue&type=template&id=0b1fbba6&"
import script from "./CheckUserAndReload.vue?vue&type=script&lang=js&"
export * from "./CheckUserAndReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports